<template>
    <div v-if="!confirmedRemove" class="space-single">
        <div v-if="editable" class="space-single-editbuttons">
            <a :href="editSpaceUrl" class="inline-edit">
                <i class="fa-pencil fa"/>Edit this space
            </a><br />
            <button class="inline-edit remove" @click.prevent="removeSpace">
                <i class="fa-trash-o fa"/>
                <template v-if="!clickedRemove">Remove</template>
                <template v-else>Are you sure?</template>
            </button>
        </div>
        <a :href="spaceUrl" class="space-thumbnail" :style="{ 'background-image': 'url(' + image + ')' }"></a>
        <div class="space-single-info">
            <h4><a :href="spaceUrl">{{ title }}</a></h4>
            <div class="space-single-details">
                <div>{{ rentalOptionsToText }} Parking</div>
                <div v-if="dummy" >
                    <div class="dummyspaceinfo">This is a dummy space</div>
                </div>
            </div>
        </div>
        <div class="space-single-buttons">
            <div>
                <a :href="spaceUrl">More info</a>
            </div>
            <div>
                <a class="btn btn-primary" :disabled="dummy" :href="spaceUrl">Book parking</a>
            </div>
        </div>
    </div>
</template>

<script>
    import WhitelabelRepository from '../../repositories/WhitelabelRepository.js';
    import { getViewData } from '../../modules/view-data';

    export default {
        name: 'space-single',

        props: {
            instance: {
                type: Number,
            },
            id: {
                type: Number,
            },
            spaceId: {
                type: Number,
            },
            title: {
                type: String,
            },
            rentalOptions: {
                type: Array,
            },
            image: {
                type: String,
            },
            editable: {
                type: Boolean,
            },
            dummy: {
                type: Boolean,
            },
        },

        data () {
            return {
                clickedRemove: false,
                confirmedRemove: false,
            }
        },

        computed: {
            rentalOptionsToText () {
                return this.rentalOptions.join(' & ');
            },

            spaceUrl () {
                return window.YPS.router.route('space.show', { spaceId: this.spaceId });
            },

            spaceUrl () {
                return this.$laroute.route('space.show', { spaceId: this.spaceId });
            },

            bookUrl () {
                return this.$laroute.route('space.book', { spaceId: this.spaceId });
            },

            editSpaceUrl () {
                return getViewData('CLIENT_API_URL_BASE') + this.$laroute.route('list-space.about-edit', { id: this.spaceId });
            },
        },

        methods: {
            removeSpace () {
                if (this.clickedRemove) {
                    WhitelabelRepository
                        .deleteSpace(this.instance, this.spaceId)
                        .then(() => this.confirmedRemove = true)
                        .catch(() => {});
                } else {
                    this.clickedRemove = true;
                }
            },
        },
    }
</script>

<style lang="less" scoped rel="stylesheet/less">
    @import (reference) "~assets/less/variables.less";
    @import (reference) "~bootstrap/less/mixins/clearfix.less";
    @import (reference) "~bootstrap/less/mixins/grid.less";
    @import (reference) "~bootstrap/less/mixins/size.less";

    .inline-edit {
        font-size: 11px;
        color: #40433a;
        font-weight: 600;
        font-family: @headings-font-family;
        background-color: #ffffff;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.27);
        padding: 5px 8px;
        border: none;
        border-radius: 4px;
        display: inline-block;
        outline: none;
        text-decoration: none;
        margin-bottom: 6px;

        &:disabled {
            opacity: 0.7;
        }

        i {
            margin-right: 5px;
            color: @YPS-secondary;
        }

        &.remove {
            i {
                color: #d02f2f;
            }
        }
    }

    .space-single {
        .make-xs-column(6);
        @media (max-width: 580px) {
            width: 100%;
        }
        .make-sm-column(12);
        .make-md-column(6);
        .make-lg-column(4);

        @media (min-width: 1600px) {
            width: 25%;
        }

        position: relative;
        margin-bottom: 35px;

        .space-single-editbuttons {
            position: absolute;
            top: 10px;
            left: 23px;
        }

        .space-thumbnail {
            padding-top: 64%;
            background-size: cover;
            background-position: center;
            display: block;
            border-radius: 4px;
        }

        .space-single-info {
            padding: 20px 0px;

            h4 {
                font-size: 20px;
                margin-top: 0px;
                a {
                    color: #345972;
                    text-decoration: none;
                }
            }

            .space-single-details {
                display: table;
                width: 100%;
                padding: 0;
                margin: 0;

                > div {
                    display: block;
                    width: 100%;
                    vertical-align: middle;

                    &:last-child {
                        text-align: left;
                        margin-top: 10px;
                    }

                    &:first-child {
                        font-size: 13px;
                        text-align: left;
                    }

                    .dummyspaceinfo {
                        color: #263946;
                        font-family: @headings-font-family;
                        font-size: 11px;
                        font-weight: 500;
                        background-color: #e8e8e8;
                        padding: 5px 11px;
                        display: inline-block;
                        border-radius: 4px;
                        text-align: center;
                    }
                }
            }
        }

        .space-single-buttons {
            border-top: 1px solid #dcdcdc;
            border-bottom: 1px solid #dcdcdc;

            &:after {
                clear: both;
                display: block;
                content: '';
            }

            > div:first-child {
                width: 40%;
                float: left;
                font-size: 13px;
                padding: 17px 0px 14px 0;
                border-right: 1px solid #dcdcdc;

                // unfortunately gets squeezed and breaks the line on this screen width range
                @media (min-width: 581px) and (max-width: 620px) {
                    font-size: 11px;
                    padding: 13px 0px 13px 0;
                }

                a {
                    display: block;
                    text-transform: uppercase;
                    color: #263946;
                    font-weight: 200;
                    padding-right: 20px;

                    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAANCAYAAACUwi84AAAA2UlEQVQoU42ROwrCUBBF7+QZ7d2KGnEBsdEdWAi6ARM/taWgJkEbBcHG2k8hGLSw9Lea2MobeUIkEUGnmsschrl3CAAKzi6dCk7Bsdt9KB0tyvS3eaGnVix5dLXN3hdgVxK62AAkAO5cGmY/tkGJnOtXiMQcgE7M7bNlDkKIwsZw/CpIzEBIgGXzYhUdNXsDSmTdfU0DTaNQDFCQ4R4WIFSYcSeJbAwwPL8OFhO1QUq2b7bp/ndD1AVDtq6N4vDtwvD8MqCtVQ6fFl8uVJJaIrkEY/w1yV+/eAJ2qluzbO/AgwAAAABJRU5ErkJggg==');
                    background-position: 90% center;
                    background-repeat: no-repeat;
                }
            }
            > div:last-child {
                width: 60%;
                float: left;
                padding: 9px 11px 8px 11px;
                a.btn {
                    padding: 9px 12px;
                    font-size: 11px;
                    width: 100%;
                    text-transform: uppercase;
                    font-family: @headings-font-family;
                }
            }
        }
    }
</style>
